<template>
  <div class="bg">
    <div class="content">
      <el-form
        ref="infoForm"
        :model="infoForm"
        :rules="rules"
        label-width="auto"
        label-position="left"
        status-icon
        :inline-message="true"
      >
        <el-card>
          <el-form-item label="照片：" prop="url">
            <el-upload
              id="upload"
              class="avatar-uploader"
              action="#"
              :http-request="uploadPic"
              accept="image/*"
              capture="camera"
              :show-file-list="false"
              :on-change="handlePictureCardPreviewurl"
            >
              <el-image v-if="url" :src="url" fit="contain" class="avatar"> </el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
            </el-upload>
          </el-form-item>
          <div>
            <el-form-item label="所属项目：" prop="projectId">
              <span>{{ projectId }}</span>
            </el-form-item>

            <el-form-item label="参建单位：" prop="unitId">
              <span @click="Unit">{{ unit }}</span>
              <van-popup
                v-model="showUnitPopup"
                round
                position="bottom"
                :style="{
                  height: 45,
                }"
              >
                <van-picker
                  title="请选择参建单位"
                  show-toolbar
                  :columns="unitOptions"
                  @confirm="onConfirmUnit"
                  @cancel="showUnitPopup = false"
                />
              </van-popup>
            </el-form-item>
            <el-form-item label="所属班组：" prop="teamId">
              <span @click="showTeamPopup = true">{{ team }}</span>
              <van-popup
                v-model="showTeamPopup"
                round
                position="bottom"
                :style="{
                  height: 45,
                }"
              >
                <van-picker
                  title="请选择所属班组"
                  show-toolbar
                  :columns="teamOptions"
                  @confirm="onConfirmTeam"
                  @cancel="showTeamPopup = false"
                />
              </van-popup>
            </el-form-item>
            <el-form-item label="姓名：" @click="getPermission()">
              <el-input v-model="infoForm.name" placeholder="请输入姓名"></el-input>
              <el-button v-if="!showRecorder" @click="startRecorder()" type="mini"
                >开启语音输入</el-button
              >
              <el-button v-if="showRecorder" @click="stopRecorder()" type="mini"
                >结束语音输入</el-button
              >
            </el-form-item>
            <el-form-item label="日工资：" prop="dailyWage">
              <el-input
                v-model="infoForm.dailyWage"
                placeholder="请输入日工资"
              ></el-input>
            </el-form-item>
          </div>
        </el-card>
      </el-form>
      <div class="btn">
        <router-link :to="{ path: '/temporaryPerson' }">
          <el-button size="small" type="info">返回</el-button>
        </router-link>
        <el-button size="small" type="primary" @click="submitForm()"> 提交 </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { postFile } from "@/api/file";
import { compress } from "@/utils/file";
import { filtration$ } from "@/utils/admin";
import formRules from "@/utils/formRules.js";
import { postListUnit } from "@/api/app/unit";
import { postListTeam } from "@/api/app/team";
import { postSpeechRecognition } from "@/api/publicServer/index";
import { getProjectList, postProjectId } from "@/api/app/project";
import { postSubmitForm } from "@/api/app/temporaryPerson";
let urlSuccess = 0;

// 语音输入
import Recorder from "js-audio-recorder";
import { stringify } from "qs";
// const lamejs = require("lamejs");
const recorder = new Recorder({
  sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
  sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
  numChannels: 1, // 声道，支持 1 或 2， 默认是1
  // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
});
export default {
  data() {
    return {
      dialogImageUrl: "",
      upload: "",
      // 所属项目
      projectId: "",
      loadProgress: 0, // 动态显示进度条
      progressFlag: false, // 关闭进度条
      // 参建单位
      unitOptions: [],
      unit: "请选择参建单位",
      showUnitPopup: false,
      // 所属班组
      teamOptions: [],
      team: "请选择所属班组",
      showTeamPopup: false,
      // 大头照
      url: "",
      // 新增信息表单
      infoForm: {
        name: "",
        url: "",
      },
      showRecorder: false,
      dialogVisible: false,
      // 防止重复提交
      loading: false,
      // 验证规则
      rules: {
        url: [{ required: true, message: "工人照片不能为空" }],
        // projectId: [{ required: true, message: "所属项目不能为空" }],
        unitId: [{ required: true, message: "参建单位不能为空" }],
        teamId: [{ required: true, message: "所属班组不能为空" }],
        dailyWage: [
          { required: true, message: "工资不能为空" },
          { validator: formRules.validateNumber, message: "工资必须为数字值" },
        ],
      },
    };
  },
  created() {
    this.$store.dispatch("submitToken");
    this.options();
  },
  methods: {
    // 获取麦克风权限
    getPermission() {
      Recorder.getPermission().then(
        () => {
          this.$Message.success("获取权限成功");
        },
        (error) => {
          console.log(`${error.name} : ${error.message}`);
        }
      );
    },
    // 开始录音
    startRecorder() {
      recorder.start().then(
        () => {},
        (error) => {
          // 出错了
          console.log(`${error.name} : ${error.message}`);
        }
      );
      this.showRecorder = true;
    },
    // 结束录音
    stopRecorder() {
      recorder.stop();
      this.getRecorder();
      this.showRecorder = false;
    },
    /**
     *  获取录音文件
     * */
    getRecorder() {
      let toltime = recorder.duration; //录音总时长
      let fileSize = recorder.fileSize; //录音总大小
      //录音结束，获取取录音数据
      let PCMBlob = recorder.getPCMBlob(); //获取 PCM 数据
      let wav = recorder.getWAVBlob(); //获取 WAV 数据
      let channel = recorder.getChannelData(); //获取左声道和右声道音频数据
      const fileReader = new FileReader();
      this.blobToBase64(PCMBlob).then((base) => {
        // 转化后的base64
        let base64 = base.substring(37);
        // console.log(base64);
        postSpeechRecognition(JSON.stringify(base64)).then((res) => {
          this.infoForm.name = res.data.replace("。", "");
        });
      });
    },
    // blbo转banse64
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          resolve(e.target.result);
        };
        // readAsDataURL
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error("blobToBase64 error"));
        };
      });
    },
    uploadPic() {},
    // 大头照照片上传
    handlePictureCardPreviewurl(file) {
      if (file.status == "ready") {
        let _that = this;
        let params = {};
        params.folderName = "big_head_photo";
        const isLt15M = file.size / 1024 / 1024 < 15;
        const isLt1M = file.size / 1021 / 1024 < 0.5;
        if (!isLt15M) {
          _that.$notify({
            type: "error",
            message: "上传图片大小不能超过 15M！",
          });
          return false;
        } else {
          compress(file.raw, function (val) {
            let newFile = new window.File([val], file.name, {
              type: file.raw.type,
            });
            let reader = new FileReader();
            reader.readAsDataURL(newFile);
            reader.onload = (e) => {
              if (e.currentTarget.result.search("png") !== -1) {
                params.format = "png";
                let base64 = e.currentTarget.result.replace("data:image/png;base64,", "");
                params.content = base64;
              }
              if (e.currentTarget.result.search("jpeg") !== -1) {
                params.format = "jpeg";
                let base64 = e.currentTarget.result.replace(
                  "data:image/jpeg;base64,",
                  ""
                );
                params.content = base64;
              }
              postFile(params).then((res) => {
                if (res.code == 200) {
                  _that.url = res.data.url;
                  _that.infoForm["url"] = res.data.path;
                  _that.$notify({ type: "success", message: "照片选择成功！" });
                  urlSuccess = 1;
                } else {
                  _that.$notify({
                    type: "error",
                    message: "照片选择失败！请重新选择。",
                  });
                }
              });
            };
          });
        }
      }
    },
    // 选择器选项
    options() {
      getProjectList().then((res) => {
        let projectId = res.data[0].id;
        // 所属项目
        postProjectId(projectId).then((res) => {
          this.projectId = res.data.name;
          this.infoForm["projectId"] = res.data.id;
          // 项目下所属的参建单位
          postListUnit(res.data.id).then((res) => {
            this.unitOptions = res.data.map((item) => {
              return { text: item.title, ...item };
            });
          });
        });
      });
    },

    // 参建单位
    Unit() {
      this.showUnitPopup = true;
    },
    // 参建单位选择
    onConfirmUnit(value) {
      this.unit = value.title;
      this.infoForm["unitId"] = value.value;
      this.showUnitPopup = false;
      // 参建单位下所属班组
      postListTeam(value.id).then((res) => {
        this.teamOptions = res.data.map((item) => {
          return { text: item.title, ...item };
        });
      });
    },
    // 所属班组
    onConfirmTeam(value) {
      this.team = value.title;
      this.infoForm["teamId"] = value.value;
      this.showTeamPopup = false;
    },
    // 提交表单
    submitForm() {
      if (urlSuccess === 1) {
        this.$refs["infoForm"].validate((valid) => {
          if (valid) {
            postSubmitForm(filtration$(this.infoForm))
              .then((res) => {
                if (res.code == 200) {
                  this.$notify({ type: "success", message: "添加成功！" });
                  // this.$refs["infoForm"].resetFields();
                  this.infoForm.url = "";
                  this.url = "";
                  this.infoForm.name = "";
                  // this.$router.push("/temporaryPerson");
                }
              })
              .catch((error) => {
                this.$store.dispatch("submitToken");
              });
          }
        });
      } else {
        this.$notify({ type: "warning", message: "请耐心等待照片上传完毕！" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
// 图片
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.bg {
  margin-bottom: 50px;
  min-height: 100vh;
  background-color: #f0f0f0;
}

.content {
  padding: 10px;
  /deep/.el-card {
    margin-bottom: 10px;
    .van-uploader:first-child {
      margin-right: 15px;
    }
    p {
      i {
        font-size: 12px;
        white-space: nowrap;
      }
      span {
        font-size: 12px;
      }
    }
    .el-form-item {
      margin: 3px 0 0 0;
    }
    .el-form-item__label {
      padding: 0;
    }
    .el-input__inner {
      border: unset;
      padding: 0;
    }
  }
  .btn {
    text-align: right;
  }
}
/deep/ .el-dialog {
  width: 100%;
  margin: 0 auto;
}
.cropper-content {
  .cropper {
    width: auto;
    height: 330px;
  }
}
</style>
